import { render, staticRenderFns } from "./draft_auction.vue?vue&type=template&id=2c0d4e48&scoped=true"
import script from "./draft_auction.vue?vue&type=script&lang=js"
export * from "./draft_auction.vue?vue&type=script&lang=js"
import style0 from "./draft_auction.vue?vue&type=style&index=0&id=2c0d4e48&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0d4e48",
  null
  
)

export default component.exports